/* eslint-disable max-len */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'

import LoadingInfo from '../../../LoadingInfo'

import Logo from '../../base/components/Logo'
import ListFilter from '../components/ListFilter'
import List from '../components/List'

const content = {
  program: 'Programme',
  museum: 'Museen',
  guidedTour: 'Themenführungen'
}

const getSortValue = (sortBy, obj) => {
  const DEFAULT_VAL = '-'
  try {

    let retval = DEFAULT_VAL
    const museum = obj.museumId ? obj.museum : obj

    if (sortBy === 'district') {
      // retval = (window.APP_CONFIG.districts
      // .find(district => district.id === museum.districtId) || { name: DEFAULT_VAL }).name
      retval = (window.APP_CONFIG.list_region
        .find(region => region.id === museum.address.region * 1) || { name: DEFAULT_VAL }).title
    }
    else if (sortBy === 'location') {
      retval = museum.address.location
    }
    else {
      retval = obj[sortBy]
    }

    obj.sortValue = retval || DEFAULT_VAL

    return `${retval || DEFAULT_VAL}`
      .match(/[-0-9a-zöäü\s]/ig)
      .join('')
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/ö/g, 'oe')
  }
  catch (ex) {
    console.error(ex)
    return DEFAULT_VAL
  }
}

export default function connectListContainer(storeName) {

  @inject(stores => ({
    provider: stores[storeName],
    ui: stores.ui
  })) @observer
  class ConnectedListContainer extends Component {

    static propTypes = {
      children: PropTypes.node,
      provider: PropTypes.object.isRequired,
      router: PropTypes.shape({
        goBack: PropTypes.func
      }).isRequired,
      ui: PropTypes.object.isRequired,
    };

    constructor(props) {
      super(props)
      this.state = {
        showOnlyBookable: false
      }
    }

    componentDidMount() {
      if (this.props.provider.collection.length < 5) {
        this.props.provider.load()
      }
    }

    @autobind
    handleChange({ target: { value } }) {
      this.props.ui.setFilter(storeName, value)
    }

    @autobind
    handleGoBack() {
      this.props.router.goBack()
    }


    @autobind
    handleShowOnyBookable() {
      this.setState((oldState) => {
        return { ...oldState, showOnlyBookable: !oldState.showOnlyBookable }
      })
    }

    renderList() {
      const { ui, provider } = this.props

      const filter = ui[`${storeName}Filter`] || { search: '', sortBy: '' }

      if (provider.loading) {
        return (
          <LoadingInfo>
            {content[storeName]}
            {' '}
            werden geladen.
          </LoadingInfo>
        )
      }

      if (!provider.collection.length) {
        return (
          <div>
            Keine
            {content[storeName]}
          </div>
        )
      }

      let collection = provider.filter(filter)
      if (this.state.showOnlyBookable) {
        collection = collection.filter(entry => !entry.temporarilyNotBookable)
      }

      const sortBy = filter.sortBy || (storeName === 'museum' ? 'name' : 'title')

      collection = collection.sort((a, b) => {
        return getSortValue(sortBy, a)
          < getSortValue(sortBy, b) ? -1 : 1
      })

      const countInfo = provider.collection.length === collection.length ? provider.collection.length : `${collection.length} von ${provider.collection.length}`
      return (
        <div>

          <h2>
            Beteiligte
            {content[storeName]}
            {' '}
            <span>
              (
              {countInfo}
              )
            </span>
          </h2>

          <button
            className="btn btn-small btn-primary"
            onClick={this.handleGoBack}
          >
            <i className="glyphicon glyphicon-chevron-left" />
&nbsp;Zurück
          </button>

          <List
            collection={collection}
            storeName={storeName}
            fullIndex={sortBy !== 'title' && sortBy !== 'name'}
          />

        </div>
      )
    }

    render() {

      const { ui } = this.props

      const camelcased = storeName.replace(
        /([A-Z])/,
        (all, match) => `-${match.toLowerCase()}`
      )

      const filter = ui[`${storeName}Filter`] || { search: '', sortBy: '' }

      return (
        <div className="row horizontal">

          <aside className="col-sm-3">

            <div className="app-sidebar">
              <Logo />

              <ListFilter
                filter={filter}
                onChange={this.handleChange}
                type={storeName}
              />

              <label className="only-bookable-filter">
                <input checked={this.state.showOnlyBookable} onChange={this.handleShowOnyBookable} type="checkbox" />
                <span>nur aktuell buchbare Einträge anzeigen</span>
              </label>

            </div>

          </aside>

          <div className={`col-sm-9 ${camelcased}-list`}>
            {this.renderList()}
          </div>

        </div>
      )
    }

  }

  return withRouter(ConnectedListContainer)
}



// WEBPACK FOOTER //
// ./src/frontend/shared/connectors/ListContainer.js